import React from 'react';
import '../css/pages/About.css';
import image1 from '../images/flavio-bianchetti.jpg';
import image2 from '../images/ifet.png';
import image3 from '../images/unipac.png';
import image4 from '../images/trybe.png';

function About() {

  return (
    <div id="about" className="container-about">
      <section className="about-section">
        <h1
          className="page-header"
        >
          Olá! Eu sou Flávio Bianchetti.
        </h1>
        <div
          className="about-card"
        >
          <div className="about-div">
            <img
              className="about-my-image"
              src={ image1 }
              alt="Flavio Bianchetti"
            />
            <div className="about-description">
              <p>
                Meu nome completo é Flávio José Bianchetti, tenho 47 anos, sou casado e 
                pai de dois filhos. Moro em Barbacena, Minas Gerais - Brasil. Sou apaixonado 
                pela minha família e pela tecnologia.
              </p>
              <p
                className="about-description-more-2"
              >
                Sou Técnico em Informática pela Escola Agrotécnica Federal de Barbacena
                (
                  <a
                    href="https://www.ifsudestemg.edu.br/barbacena"
                    target="_blank"
                    rel="noreferrer"
                  >
                    IFET
                  </a>
                ), Graduado em Ciência da Computação pela Universidade Presidente Antônio Carlos
                (
                  <a
                    href="https://www.unipac.br/barbacena/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    UNIPAC
                  </a>
                ) e estudante de desenvolvimento web na &nbsp;
                  <a
                    href="https://www.betrybe.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Trybe
                  </a>
                .
              </p>
              <p
                className="about-description-more-1"
              >
                Sou Técnico em Informática pela Escola Agrotécnica Federal de Barbacena
                (
                  <a
                    href="https://www.ifsudestemg.edu.br/barbacena"
                    target="_blank"
                    rel="noreferrer"
                  >
                    IFET
                  </a>
                ), no ano 2000. Durante o curso foram trabalhados conceitos de programação
                lógica, linguagens de programação, banco de dados e manutenção de equipamentos.
              </p>
              <p
                className="about-description-more-1"
              >
                Tenho bacharelado em Ciência da Computação pela Universidade Presidente Antônio Carlos
                (
                  <a
                    href="https://www.unipac.br/barbacena/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    UNIPAC
                  </a>
                ), em 2010. O curso visa capacitar o profissional a desenvolver investigação e implementação
                de sistemas computacionais em empresas públicas e privadas, desenvolvendo projetos e
                soluções nas áreas de modelagem matemática, inteligência artificial, programação para internet
                e sistemas de software para diferentes plataformas.
              </p>
              <p
                className="about-description-more-1"
              >
                Atualmente sou estudante de desenvolvimento web na &nbsp;
                <a
                    href="https://www.betrybe.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Trybe
                  </a>
                . O programa de treinamento de Desenvolvimento Web da Trybe tem uma carga de trabalho 
                de 1500 horas, que abrange front-end, back-end, ciência da computação, engenharia de 
                software, metodologias ágeis e soft skills. Os principais conteúdos técnicos estudados 
                são JavaScript, HTML, CSS, React, Node, Express.js, SQL, Git [...] entre outras 
                linguagens e frameworks.
              </p>
            </div>
          </div>
          <div
            className="about-institutes"
          >
            <a
              href="https://www.ifsudestemg.edu.br/barbacena"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="about-images"
                src={ image2 }
                alt="IF-Sudeste - Campus Barbacena"
              />
            </a>
            <a
              href="https://www.unipac.br/barbacena/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="about-images"
                src={ image3 }
                alt="University Presidente Antônio Carlos - UNIPAC"
              />
            </a>
            <a
              href="https://www.betrybe.com"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="about-images"
                src={ image4 }
                alt="Trybe"
              />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
